import { createSlice } from '@reduxjs/toolkit';

const activeComponentSlice = createSlice({
    name: 'activeComponent',
    initialState: {
      activeComponent: 'getStarted',
    },
    reducers: {
      setActiveComponent: (state, action) => {
        state.activeComponent = action.payload;
      },
      clearActiveComponent: (state) => {
        state.activeComponent = null;
      }
    },
  });
  
  export const { setActiveComponent, clearActiveComponent } = activeComponentSlice.actions;
  export default activeComponentSlice.reducer;